import agendamentoExame from './agendamentoExame'
import agendamentoExameRetroativo from './agendamentoExameRetroativo'
import assinaturaEletronica from './assinaturaEletronica'
import cancelamentoResultado from './cancelamentoResultado'
import coletaAgendada from './coletaAgendada'
import confirmacaoColeta from './confirmacaoColeta'
import entregaExame from './entregaExame'
import exameAgendadoRealizado from './exameAgendadoRealizado'
import exameProducao from './exameProducao'
import exameSolicitadoStatus from './exameSolicitadoStatus'
import formulaExame from './formulaExame'
import importarLaudo from './importarLaudo'
import impressaoExame from './impressaoExame'
import impressoes from './impressoes'
import jornada from './jornada'
import jornadaBloqueio from './jornadaBloqueio'
import lancamentoColeta from './lancamentoColeta'
import lancamentoResultado from './lancamentoResultado'
import mapaDia from './mapaDia'
import mapaProducao from './mapaProducao'
import parametrizacao from './parametrizacao'
import relatorioColetaRealizada from './relatorioColetaRealizada'
import relatorioCotaConsumo from './relatorioCotaConsumo'
import relatorioExameBloqueado from './relatorioExameBloqueado'
import relatorioExameLaboratorioApoio from './relatorioExameLaboratorioApoio'
import relatorioFinanceiroExame from './relatorioFinanceiroExame'
import relatorioFinanceiroPaciente from './relatorioFinanceiroPaciente'
import relatorioHistoricoPaciente from './relatorioHistoricoPaciente'
import relatorioPacienteAtendido from './relatorioPacienteAtendido'
import relatorioQuantitativoExameSolicitado from './relatorioQuantitativoExameSolicitado'
import relatorioQuantitativoProducao from './relatorioQuantitativoProducao'

export default [
    {
        path: 'exame-laboratorial',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...agendamentoExame,
            ...agendamentoExameRetroativo,
            ...assinaturaEletronica,
            ...cancelamentoResultado,
            ...coletaAgendada,
            ...confirmacaoColeta,
            ...entregaExame,
            ...exameAgendadoRealizado,
            ...exameProducao,
            ...exameSolicitadoStatus,
            ...formulaExame,
            ...importarLaudo,
            ...impressaoExame,
            ...impressoes,
            ...jornada,
            ...jornadaBloqueio,
            ...lancamentoColeta,
            ...lancamentoResultado,
            ...mapaDia,
            ...mapaProducao,
            ...parametrizacao,
            ...relatorioColetaRealizada,
            ...relatorioCotaConsumo,
            ...relatorioExameBloqueado,
            ...relatorioExameLaboratorioApoio,
            ...relatorioFinanceiroExame,
            ...relatorioFinanceiroPaciente,
            ...relatorioHistoricoPaciente,
            ...relatorioPacienteAtendido,
            ...relatorioQuantitativoExameSolicitado,
            ...relatorioQuantitativoProducao,
        ]
    }
]
